/** Page size for GET /library/query (must match backend default/limit handling). */
export const CATALOG_QUERY_PAGE_LIMIT = 50;
